import { useParams } from "react-router-dom";

import { TemplateEditionForm } from "../components/forms/TemplateEditionForm.tsx";
import { FormSkeleton } from "../components/skeletons/FormSkeleton.tsx";
import { useError } from "../hooks/useError.ts";
import { useFormatHtml } from "../hooks/useFormatHtml.ts";
import { useTemplateQuery } from "../hooks/useTemplateQuery.ts";
import { ErrorPage } from "./ErrorPage.tsx";

export function TemplateEditionPage() {
  const { templateId } = useParams();
  const { template, isError, isLoading, queryError } = useTemplateQuery(templateId);
  const { customFormatHtml } = useFormatHtml();
  const { errorMessage } = useError(queryError);

  const contentRows = isLoading ? (
    [<FormSkeleton key="skeleton" />]
  ) : (
    <TemplateEditionForm
      id={template?.id}
      code={template?.code}
      variables={template?.variables}
      body={customFormatHtml(template?.body)}
      subject={template?.subject}
      overrideSubject={template?.overrideSubject}
      overrideBody={template?.overrideBody}
      defaultSubject={template.defaultSubject}
      defaultBody={template.defaultBody}
    />
  );

  return isError ? (
    <ErrorPage
      code={errorMessage.code}
      title={errorMessage.title}
      description={errorMessage.description}
    />
  ) : (
    contentRows
  );
}
